module.exports = __webpack_public_path__ + "static/media/affinity.4d695855.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/Cooleaf/affinity.png
// module id = 138
// module chunks = 0